module.exports = __webpack_public_path__ + "1c8738f0b9ef489640a59e4bded71e8a.png";